// import { Button, Grid } from '@material-ui/core';
import React, { useState, useEffect } from "react";
// import theme from 'theme';
import PropTypes from "prop-types";
import FaqItem from "./components/FaqItem";
import { connect } from "react-redux";
import * as actions from "redux/actions/faqActions";
// import Typography from '@mui/material/Typography';
import { Translate, I18n } from "react-redux-i18n";
import { SearchInput } from 'components';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import 'assets/css/faq.css';

// const useStyles = {
//     root: {
//         padding: theme.spacing(3),
//     },
//     content: {
//         marginTop: theme.spacing(2),
//     },
// };

const Faq = (props) => {
 
    const { className, history, ...rest } = props;
    const [question, setQuestion] = useState("");

    useEffect(() => {
        props.loadList({
            id: props.user_id,
            lang: props.lang,
            status: 'APPROVED',
        }, props.token);
    }, [props.user_id, props.lang]);

    const onClick = () => {
        props.newItem({
            id: props.user_id,
            question: question,
            lang: props.lang
        }, props.token);
        setQuestion("");
        alertify.success("Success");
    }

    const onChange = (event) => {
        setQuestion(event.target.value);
    }

    return (
        <div className="faq-page" >
            <div className="faq-header">
                <div>
                    <h1 className="faq-title">
                        <Translate value="faq" />
                    </h1>
                    <p className="faq-subtitle">
                        Ask a question and browse answers.
                    </p>
                </div>
            </div>

            <div className="faq-card">
                <div className="faq-ask-row">
                    <div className="faq-ask-input">
                        <input
                        className="search-input"
                            onChange={onChange}
                            value={question}
                        />
                    </div>
                    <button
                    className='btn btn-primary btn-search'
                        // color="primary"
                        onClick={onClick}
                        // variant="contained"
                        // className="faq-send-btn"
                    >
                        <Translate value="send" />
                    </button>
                </div>

                <div className="faq-list">
                    {props.list.map((item) => (
                        <FaqItem
                            key={item.id}
                            item={item}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

Faq.propTypes = {
    className: PropTypes.string,
    history: PropTypes.object
};
// <Toolbar history={history} />
// <Table list={props.list} />
function mapStateToProps(reducer) {
    //console.log(reducer);
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
        lang: reducer.i18n.locale,
        list: reducer.faq.list,
        error: reducer.faq.error,
        loading: reducer.faq.loading,

    };
}
const mapDispatchToProps = dispatch => ({
    loadList: (params, token) =>
        dispatch(actions.loadList({ params, token })),
    newItem: (params, token) =>
        dispatch(actions.newItem({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Faq);